'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = require('react');
var _ = require('lodash');
var compose = require('../hoc/compose');
var template = require('./radioButtons.rt');
var displayNames = require('./displayNames');

var Label = function Label(props) {
    return React.createElement('div', { className: 'radio-button-label' }, props.label || props.value);
};

var generateChildrenFromOptions = function generateChildrenFromOptions(options, labelTemplate, allDisabled) {
    return _.map(options, function (itemProps) {
        var newProps = _.isObject(itemProps) ? itemProps : { value: itemProps };
        _.defaults(newProps, { disabled: allDisabled });
        return labelTemplate ? React.createElement(labelTemplate, newProps) : React.createElement(Label, newProps);
    });
};

var RadioButtons = function (_React$Component) {
    _inherits(RadioButtons, _React$Component);

    function RadioButtons(props) {
        _classCallCheck(this, RadioButtons);

        var _this = _possibleConstructorReturn(this, (RadioButtons.__proto__ || Object.getPrototypeOf(RadioButtons)).call(this, props));

        _this.groupId = _.uniqueId('radioGroup');
        _this.generateChildren = function () {
            return _this.props.options ? generateChildrenFromOptions(_this.props.options, _this.props.labelTemplate, _this.props.disabled) : _this.props.children;
        };
        return _this;
    }

    _createClass(RadioButtons, [{
        key: 'render',
        value: function render() {
            return template.call(this);
        }
    }]);

    return RadioButtons;
}(React.Component);

RadioButtons.displayName = displayNames.RADIO_BUTTONS;
RadioButtons.propTypes = {
    value: React.PropTypes.string,
    onChange: React.PropTypes.func.isRequired,
    labelTemplate: React.PropTypes.oneOfType([React.PropTypes.object, React.PropTypes.func]),
    options: React.PropTypes.oneOfType([React.PropTypes.arrayOf(React.PropTypes.string), React.PropTypes.arrayOf(React.PropTypes.shape({
        value: React.PropTypes.string.isRequired,
        label: React.PropTypes.string,
        disabled: React.PropTypes.bool
    }))]),
    disabled: React.PropTypes.bool,
    radioItemPredicate: React.PropTypes.func,
    orientation: React.PropTypes.oneOf(['horizontal', 'vertical']),
    showRadioSymbol: React.PropTypes.bool
};
RadioButtons.defaultProps = {
    disabled: false,
    radioItemPredicate: function radioItemPredicate(item) {
        return _.has(item, 'props.value');
    },
    orientation: 'vertical',
    showRadioSymbol: true
};

module.exports = compose(RadioButtons);


// WEBPACK FOOTER //
// ./~/wix-base-ui/lib/controls/radioButtons.js